const servicesList = [
    {
        id: 1,
        title: {
            en: 'UX/UI design',
            ua: 'UX/UI Дизайн',
            ru: 'UX/UI Дизайн',
            de: 'Shopify UX/UI Design',
        },
        description: {
            en: 'We create intuitive and visually appealing interfaces that provide a comfortable user experience, improving interaction with the product and engaging users with websites and mobile applications.',
            ua: 'Ми створюємо інтуїтивно зрозумілі та візуально привабливі інтерфейси, які забезпечують комфортний користувацький досвід, покращують взаємодію з продуктом та залучають користувачів до використання веб-сайтів і мобільних додатків.',
            ru: 'Мы создаем интуитивно понятные и визуально привлекательные интерфейсы, которые обеспечивают комфортный пользовательский опыт, улучшают взаимодействие с продуктом и привлекают пользователей к использованию веб-сайтов и мобильных приложений.',
            de: 'Wir gestalten moderne, klare und verkaufsorientierte Shopify-Shops – von der Startseite über Produktseiten bis zur mobilen Nutzerführung. Fokus: Vertrauen, einfache Bedienung und mehr Verkäufe.',
        },
        value: {
            en: ['$ Individual calculation', '10-15 days'],
            ua: ['$ Індивідуальний розрахунок', '10-15 днів'],
            ru: ['$ Индивидуальный расчет', '10-15 дней'],
            de: ['ab 4.000 €', 'ab 30 Tagen'],
        },
    },
    {
        id: 2,
        title: {
            en: 'WP, Shopify',
            ua: 'WP, Shopify',
            ru: 'WP, Shopify',
            de: 'Shopify Entwicklung',
        },
        description: {
            en: 'We create flexible websites on WordPress and effective eCommerce solutions on Shopify. Our services offer customization for any task, ensuring ease of management, high performance, and stability for your business growth and success.',
            ua: 'Ми створюємо гнучкі сайти на WordPress та ефективні eCommerce-рішення на Shopify. Надаємо можливість кастомізації під будь-які завдання, забезпечуючи зручність управління, високу продуктивність і стабільність для розвитку вашого бізнесу.',
            ru: 'Мы создаем гибкие сайты на WordPress и эффективные eCommerce-решения на Shopify. Предоставляем возможность кастомизации под любые задачи, обеспечивая удобство управления, высокую производительность и стабильность для роста и успеха вашего бизнеса.',
            de: 'Wir entwickeln und optimieren Shopify-Shops mit sauberem Code, schneller Ladezeit, SEO-Grundstruktur und flexiblen Sections, die Sie später einfach selbst bearbeiten können.',
        },
        value: {
            en: ['$ Individual calculation', '15-30 days'],
            ua: ['$ Індивідуальний розрахунок', '15-30 днів'],
            ru: ['$ Индивидуальный расчет', '15-30 дней'],
            de: ['ab 3.000 €', 'ab 18 Tagen'],
        },
    },
    // {
    //     id: 3,
    //     title: {
    //         en: 'Dev. on Next.js',
    //         ua: 'Розробка на Next.js',
    //         ru: 'Разработка на Next.js',
    //         de: 'Entwicklung mit Next.js',
    //     },
    //     description: {
    //         en: 'We build web applications using the Next.js framework with a focus on high performance optimization, scalability, and clean code architecture.',
    //         ua: 'Ми створюємо веб-додатки на фреймворку Next.js з акцентом на високій оптимізації продуктивності, масштабованості та чистій архітектурі коду.',
    //         ru: 'Мы создаем веб-приложения на фреймворке Next.js с акцентом на высокую оптимизацию производительности, масштабируемость и чистую архитектуру кода.',
    //         de: 'Wir entwickeln Webanwendungen mit dem Next.js-Framework und legen den Fokus auf hohe Performance, Skalierbarkeit und eine saubere Code-Architektur.',
    //     },
    //     value: {
    //         en: ['$ Individual calculation', '15-30 days'],
    //         ua: ['$ Індивідуальний розрахунок', '15-30 днів'],
    //         ru: ['$ Индивидуальный расчет', '15-30 дней'],
    //         de: ['$ Individuelle Kalkulation', '15-30 Tage'],
    //     },
    // },
    // {
    //     id: 4,
    //     title: {
    //         en: 'Turnkey Dev.',
    //         ua: 'Розробка пiд КЛЮЧ',
    //         ru: 'Разработка под ключ',
    //         de: 'Entwicklung aus einer Hand',
    //     },
    //     description: {
    //         en: 'We conduct competitor analysis and market research, create a prototype, and then develop a turnkey solution tailored to your goals. We ensure full functionality, unique design, and technical support at every stage.',
    //         ua: 'Проводимо аналіз конкурентів і дослідження ринку, створюємо прототип, а потім розробляємо рішення "під ключ" з урахуванням ваших цілей. Забезпечуємо повну функціональність, унікальний дизайн і технічну підтримку на всіх етапах.',
    //         ru: 'Проводим анализ конкурентов и исследование рынка, создаем прототип, а затем разрабатываем решение "под ключ" с учетом ваших целей. Обеспечиваем полную функциональность, уникальный дизайн и техническую поддержку на всех этапах.',
    //         de: 'Wir führen eine Wettbewerbsanalyse und Marktrecherche durch, erstellen einen Prototyp und entwickeln anschließend eine schlüsselfertige Lösung, die auf Ihre Ziele abgestimmt ist. Wir sorgen für volle Funktionalität, individuelles Design und technische Unterstützung in jeder Phase.',
    //     },
    //     value: {
    //         en: ['$ Individual calculation', '30-60 days'],
    //         ua: ['$ Індивідуальний розрахунок', '30-60 днів'],
    //         ru: ['$ Индивидуальный расчет', '30-60 дней'],
    //         de: ['$ Individuelle Kalkulation', '30-60 Tage'],
    //     },
    // },
];

export { servicesList };
